(() => {
  function init(root) {
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const toggle = root.querySelector('[data-help-toggle]');
    const answers = [...root.querySelectorAll('details')];
    const sync = () => {
      const allOpen = answers.every(item => item.open);
      toggle.setAttribute('aria-expanded', String(allOpen));
      toggle.textContent = allOpen ? root.dataset.hideLabel : root.dataset.showLabel;
    };
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      answers.forEach(item => { item.open = open; });
      sync();
    });
    answers.forEach(item => item.addEventListener('toggle', sync));
  }
  init(document.querySelector('#quote-help'));
  document.addEventListener('shopify:section:load', () => init(document.querySelector('#quote-help')));
})();
